import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const references = [
  { id: 1, title: "Scanner Vienne", image: "/images/reference1.jpg" },
  // { id: 2, title: "Salle Kine", image: "/images/reference2.jpg" },
  { id: 3, title: "Massage Concept", image: "/images/reference3.jpg" },
  { id: 4, title: "Maison Medicale", image: "/images/reference4.jpg" },
  {
    id: 5,
    title: "Logements à Thoiry",
    image: "/images/reference5.jpg",
  },
  {
    id: 6,
    title: "Logements Saint Andre Le Gaz",
    image: "/images/reference6.jpg",
  },
  { id: 7, title: "Service De Réanimation", image: "/images/reference7.jpg" },
  { id: 8, title: "Parking", image: "/images/reference8.jpg" },
  { id: 9, title: "Salle d’intervention", image: "/images/reference9.png" },
  { id: 10, title: "Service Dialyse", image: "/images/reference10.png" },
  { id: 11, title: "Service Endoscopie", image: "/images/reference11.jpg" },
  { id: 12, title: "Bloc Operatoire Arnas", image: "/images/reference12.jpg" },
  { id: 13, title: "Pôle Sport et Sante ", image: "/images/reference13.jpeg" },
];

const ReferencesPage = () => {
  return (
    <div className="container mx-auto w-full lg:p-24 p-16">
      <Helmet>
        <title>Nos Références - MOSA Ingénierie</title>
        <meta
          name="description"
          content="Découvrez les projets réalisés par MOSA Ingénierie et notre expertise à travers nos références clients."
        />
      </Helmet>

      <h1 className="text-3xl lg:text-5xl font-bold mb-8 text-center text-[#0A827D] pb-12">
        NOS REFERENCES
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {references.map((ref) => (
          <div
            key={ref.id}
            className="bg-white shadow-lg rounded-lg overflow-hidden flex flex-col justify-center items-center"
          >
            <img
              src={ref.image}
              alt={ref.title}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="text-xl font-bold text-center mb-4">
                {ref.title}
              </h2>
              <Link to={`/reference/${ref.id}`}>
                <div className="flex justify-center items-center">
                  <button className="bg-[#0A827D] text-white px-4 py-2 rounded-full ">
                    Plus de details
                  </button>
                </div>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferencesPage;
